import { useFormContext } from '@american-autonomy/ag-ui';

import FormGrid from 'components/FormGrid';
import BoundaryNameField from 'components/fields/BoundaryNameField';
import SelectClientFarmFieldField from 'components/fields/SelectClientFarmFieldField';

import useTranslation from './hooks/useTranslation';

import { BOUNDARY_NAME_FIELD_NAME, TEST_ID } from './constants';
import type { BoundaryFormSchema, FieldPath, Props } from './types';

const BoundaryFormFields = <T extends BoundaryFormSchema>({
    children,
    namePrefix,
    testId = TEST_ID
}: Props<T>) => {
    const { control } = useFormContext<T>();
    const { BOUNDARY_NAME_FIELD_PLACEHOLDER } = useTranslation();

    const fieldName = (name: keyof BoundaryFormSchema) =>
        (namePrefix ? `${namePrefix}.${String(name)}` : String(name)) as FieldPath<T>;

    return (
        <FormGrid testId={testId}>
            <BoundaryNameField<T>
                control={control}
                isRequired={true}
                name={fieldName(BOUNDARY_NAME_FIELD_NAME)}
                placeholder={BOUNDARY_NAME_FIELD_PLACEHOLDER}
            />

            <SelectClientFarmFieldField<T> namePrefix={namePrefix} />

            {children}
        </FormGrid>
    );
};

export default BoundaryFormFields;
